import Component from "../../classes/Component";
import Swiper, {Pagination, Thumbs, Navigation} from "swiper";

const detailSliderGroupSelector = '.js-detail-slider-group'
const swiperPaginationTopSelector = '.js-swiper-pagination-detail'

export default function () {

    return new Component({
        name: 'carousel',
        requiredTargets: [detailSliderGroupSelector],
        onInit() {
            //mobile slider
            const mobileSlider = new Swiper(detailSliderGroupSelector, {
                modules: [Pagination],

                spaceBetween: 10,

                pagination: {
                    el: swiperPaginationTopSelector,
                    type: 'bullets',
                    // dynamicBullets: true,
                    // dynamicMainBullets: 3,
                    bulletActiveClass: 'swiper-pagination-bullet-active swiper-pagination-bullet-top-active',
                    bulletClass: 'swiper-pagination-bullet swiper-pagination-bullet-top'
                },
            })

            //thumbs slider
            const thumbsSlider = new Swiper('.detail__information-slider-pictures', {
                modules: [Thumbs],
                slidesPerView: 5,
                slideToClickedSlide: true,
            })

            //main slider
            const mainSlider = new Swiper('.js-main-slider', {
                modules: [Thumbs],
                slidesPerView: 1,
                thumbs: {
                    swiper: thumbsSlider,
                    slideThumbActiveClass: 'detail__information-slider-picture-active'
                },
            })


            //zoom slider
            const nextButtonSelector = '.js-zoom-next-slider-button'
            const prevButtonSelector = '.js-zoom-prev-slider-button'

            const zoomSlider = new Swiper('.js-zoom-slider', {
                modules: [Navigation],
                slidesPerView: 1,
                navigation: {
                    nextEl: nextButtonSelector,
                    prevEl: prevButtonSelector,
                },
            })

            mainSlider.on('click', () => {
                zoomSlider.slideTo(mainSlider.activeIndex)
            })

            mobileSlider.on('tap', () => {
                zoomSlider.slideTo(mobileSlider.activeIndex)
            })

        },
        onDestroy() {
            console.log('carousel')
        },
    })

}
